import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackInitiateCheckout } from '../../utils/metaPixel';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-white py-14 sm:py-16" data-id="element-163" data-mp="3linzecwpcu42">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-164" data-mp="3pjhnp7e24axh">
        <SectionTag icon="💰" data-id="element-165" data-mp="3phoeplfz1emb">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-166" data-mp="3uib1z21645yp">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-gris-texto sm:text-lg" data-id="element-167" data-mp="204jjre4rwdrn">Acceso inmediato y garantía total de 7 días.</p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-6 sm:px-8" data-id="element-168" data-mp="2534l5gvrh3ho">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-2xl border-2 border-naranja bg-bg-secondary p-6 shadow-leve sm:p-7" data-id="element-169" data-mp="255qunm27pt2j">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-gris-muted" data-id="element-170" data-mp="11l6tijcqjv9l">
            🏐 Balonmano Pro 360: La Pizarra del Entrenador
          </p>
          <p className="mt-1.5 text-xs text-gris-muted" data-id="element-171" data-mp="1u8b5576c37uc">6 tomos + 5 bonos, listos para llevar a la pista.</p>

          <div className="mt-4 space-y-1.5" data-id="element-172" data-mp="1pb14evdhv9r7">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-gris-claro py-1.5 text-sm" data-id="element-173" data-mp="1l7l9c3h2phgm">
                <span className="text-gris-texto" data-id="element-174" data-mp="9u10emvfmxtt">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-175" data-mp="4uo47bio8eek">
                  <span className="text-gris-texto" data-id="element-176" data-mp="4wr3yn9mllwh">{row.value}</span>
                  <CheckIcon size={14} className="text-verde" data-id="element-177" data-mp="6d4xjk9hz12l" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-marino" data-id="element-178" data-mp="ba52frum1xs4">
              <span data-id="element-179" data-mp="3tg9kjml5l6cw">VALOR TOTAL</span>
              <span className="text-rojo line-through" data-id="element-180" data-mp="1cgycbb47dxa">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-gris-muted" data-id="element-181" data-mp="3jq7zl3o3k427">Precio hoy (85% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-marino sm:text-6xl" data-id="element-182" data-mp="3ohyezo1w5i0h">17,99€</p>
          <span className="mt-2 inline-block rounded-full bg-naranja-light px-3 py-1 text-sm font-semibold text-black" data-id="element-183" data-mp="39stws6v3jdsd">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <div className="mt-6" data-id="element-184" data-mp="30rvohcdmkk3z">
            <PrimaryButton href={CHECKOUT_URL} onClick={trackInitiateCheckout} fullWidth data-id="element-185" data-mp="30rm0fuc54n0x">
              Quiero Balonmano Pro 360 por 17,99€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-gris-muted" data-id="element-186" data-mp="2m4n71ttq3ijk">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-187" data-mp="2h86l969zxg9n">
                <item.icon size={12} data-id="element-188" data-mp="2v6mq0roaswp5" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}